<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list>
        <v-list-group
          prepend-icon="mdi-account-edit"
          no-action
          v-if="menu.advogado || menu.escritorio"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cadastros</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item @click="redirect('/advogado')" v-if="menu.advogado">
            <v-list-item-content>
              <v-list-item-title>Advogado</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/escritorio')" v-if="menu.escritorio">
            <v-list-item-content>
              <v-list-item-title>Escritório</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group
          prepend-icon="mdi-calendar-clock"
          no-action
          v-if="menu.prazo  || menu.importacao"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Prazos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item @click="redirect('/prazo')" v-if="menu.prazo">
            <v-list-item-content>
              <v-list-item-title>Consulta</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/importacao')" v-if="menu.importacao">
            <v-list-item-content>
              <v-list-item-title>Importação</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="mdi-chart-timeline" no-action v-if="menu.relatorio">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Relatórios</v-list-item-title>
            </v-list-item-content>
          </template>
           <v-list-item @click="redirect('/financeiro')" v-if="menu.relatorio">
            <v-list-item-content>
              <v-list-item-title>Financeiro</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/relatorio')" v-if="menu.relatorio">
            <v-list-item-content>
              <v-list-item-title>Prazos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/producao')" v-if="menu.relatorio">
            <v-list-item-content>
              <v-list-item-title>Produção</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-lock-open-check"
          no-action
          v-if="menu.perfil || menu.tipo || menu.tipopendencia || menu.usuario || menu.catalogo || menu.configescritorio"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Administrativo</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item @click="redirect('/catalogo')" v-if="menu.catalogo">
            <v-list-item-content>
              <v-list-item-title>Catálogo de Serviços</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/configescritorio')" v-if="menu.configescritorio">
            <v-list-item-content>
              <v-list-item-title>Config. de Escritório</v-list-item-title>
            </v-list-item-content>
          </v-list-item>         
          <v-list-item @click="redirect('/perfil')" v-if="menu.perfil">
            <v-list-item-content>
              <v-list-item-title>Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/tipo')" v-if="menu.tipo">
            <v-list-item-content>
              <v-list-item-title>Tipos de Prazo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/tipopendencia')" v-if="menu.tipopendencia">
            <v-list-item-content>
              <v-list-item-title>Tipos de Pendência</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="redirect('/usuario')" v-if="menu.usuario">
            <v-list-item-content>
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#2A3F54" dark>
      <v-toolbar-title style="width: 200px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon @click="redirect('/prazo')">
        <v-icon>mdi-calendar-clock</v-icon>
      </v-btn>
      <v-btn icon @click="redirect('/#')">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-menu bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="redirect('/meuperfil')">
            <v-list-item-title>Perfil</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container>
        <slot></slot>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      menu: {
        advogado: false,
        escritorio: false,
        perfil: false,
        tipo: false,
        tipopendencia: false,
        usuario: false,
        prazo: false,
        importacao: false,
        relatorio: false
      }
    };
  },
  created() {
    let usuarioAux = sessionStorage.getItem("usuario");
    if (usuarioAux) {
      this.usuario = JSON.parse(usuarioAux);

      let permAux = this.$store.getters.getPermissoes;

      if (permAux.ativo) {
        this.menu = permAux;
      }
    } else {
      this.$router.push("/login");
    }
  },
  computed: {
    advogadoDisabled() {
      console.log(this.menu.advogado);
      return this.menu.advogado;
    },
    tipoDisabled() {
      return this.filtro.tipoato === 0;
    }
  },
  methods: {
    carregaMenu() {},
    redirect(rota) {
      this.$router.push(rota);
    },
    perfil: function(rota) {
      this.$router.push(rota);
    },
    logout() {
      this.$store.commit("setUsuario", null);
      sessionStorage.clear();
      this.usuario = false;
      this.$router.push("/login");
    }
  }
};
</script>

<style>
th.text-start {
  font-size: 15px;
}

th.text-left {
  font-size: 15px;
}
</style>